const INITIAL_STATE = {
  deliveryFee: 0,
  city: '',
  alias: [],
  neighborhoodsPrice: [],
  sync: [],
  loaded: false,
  isLoading: false,
};

export default function store(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'REPLACE_STORE_SUCCESS':
      return { ...action.store, loaded: true, isLoading: false };
    case 'SET_LOADING':
      return { ...state, isLoading: action.status };
    case 'INIT_STORE':
      return { ...action.store, loaded: true };
    default:
      return state;
  }
}
